import { render, staticRenderFns } from "./FormTurmaCadastro.vue?vue&type=template&id=19ef8c73"
import script from "./FormTurmaCadastro.vue?vue&type=script&lang=js"
export * from "./FormTurmaCadastro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports